module.exports = {
  context: {
    class: 'align-center',
    buttons: [
      {
        text: 'Download This File',
        url: 'https://google.com',
        fileType: 'PDF',
        fileSize: '120kb',
        class: 'primary'
      },
      {
        text: 'Download This File',
        url: 'https://google.com',
        fileType: 'PDF',
        fileSize: '120kb',
        class: 'secondary'
      },
      {
        text: 'Download This File',
        url: 'https://google.com',
        fileType: 'PDF',
        fileSize: '120kb',
        class: 'info'
      }
    ]
  }
}
